import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import "./FoodAllowance.css";
import { toast, ToastContainer } from "react-toastify";
import { useCombinedContext } from "../../context/CombinedContext";

// derive today's date, current month and year
const today = new Date();
const currentYear = today.getFullYear();
const currentMonth = String(today.getMonth() + 1).padStart(2, "0");

// years from currentYear -5 to currentYear +5
const yearsRange = Array.from({ length: 11 }, (_, i) =>
  String(currentYear - 5 + i)
);

// initial form defaults to current month, year, and date
const initialFormData = {
  month: currentMonth, // e.g. "04"
  year: String(currentYear), // e.g. "2025"
  date: today.toISOString().split("T")[0], // e.g. "2025-04-24"
  amount: "",
};

const FoodAllowanceRepayment = ({ foodallowance, onClose }) => {
  const { user } = useCombinedContext();
  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);

  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) onClose();
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = { ...formData, amount: Number(formData.amount) };

    try {
      const response = await axiosInstance.post(
        `/foodallowance/payment/${foodallowance._id}`,
        payload
      );
      toast.success(response.data.message);
      setLoading(false);
      onClose();
    } catch (error) {
      // toast.error("Something went wrong");
      toast.error( error?.response?.data?.message[0])
      // console.log("Error response:", error?.response?.data?.message[0]);
      // alert("Something went wrong"); 
      setLoading(false);
    } finally {
      // setLoading(false);
      // onClose();
    }
  };

  return (
    <div
      className="modal show d-block"
      onClick={handleOutsideClick}
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <ToastContainer />
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content foodallowance_model">
          <div className="modal-header text-white vesel_form">
            <h5 className="modal-title">Payment Form</h5>
            <button className="btn-close text-white" onClick={onClose}></button>
          </div>

          <div className="modal-body vesel_form">
            <div className="container mb-3">
              <div className="row">
                <div className="col-md-6">
                  <strong>Employee Name:</strong> {foodallowance.employee.name}
                </div>
                <div className="col-md-6">
                  <strong>Employee No:</strong>{" "}
                  {foodallowance.employee.employeeNo}
                </div>
                <div className="col-md-12 mt-2">
                  <strong>Balance to Pay:</strong> ${foodallowance.balance}
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="card shadow-sm mb-4 rounded-3">
                <div className="card-body">
                  <h5 className="card-title text-center mb-4">
                    Payment Details
                  </h5>
                  <div className="row g-3">
                    <div className="col-md-3">
                      <label className="form-label">Month</label>
                      <select
                        name="month"
                        value={formData.month}
                        onChange={handleChange}
                        className="form-select"
                        required
                      >
                        {months.map((m) => (
                          <option key={m.value} value={m.value}>
                            {m.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">Year</label>
                      <select
                        name="year"
                        value={formData.year}
                        onChange={handleChange}
                        className="form-select"
                        required
                      >
                        {yearsRange.map((y) => (
                          <option key={y} value={y}>
                            {y}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">Date</label>
                      <input
                        type="date"
                        name="date"
                        className="form-control"
                        value={formData.date}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">Amount</label>
                      <input
                        type="number"
                        name="amount"
                        className="form-control"
                        value={formData.amount}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center mt-3">
                <button type="submit" className="button-2" disabled={loading}>
                  {loading ? "Processing..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FoodAllowanceRepayment;
